import { isEmpty, isNil } from 'lodash';
import { LabTestResultGridRowItem } from '../on-screen-results/grid-row-item';
import { SubjectColumnParams } from '../on-screen-results/standard-test-results/osr-subject-columns-renderer.component';


export class SubjectTitleRenderer {
    public static get removedSubjectLabel() {
        return 'Removed';
    }

    public static renderTitle(x: SubjectTitleGetterParams): string {
        const result = [x.data.subjectNumber, x.data.initials];

        if (!x.data.zcSubjectId ) {
            return this.removedSubjectLabel;
        }

        const numberAndInitials = result.filter(item => !isEmpty(item)).join(' - ');

        if (numberAndInitials) {
            return numberAndInitials;
        }

        if (x.data.screeningNumber) {
            return x.data.screeningNumber;
        }

        return `No ID (ZC${x.data.zcSubjectId})`;
    }

    public static renderSubjectTitle(x: LabTestResultGridRowItem): SubjectColumnParams {
        const subjectNumberAndInitials = this.renderTitle(x);
        const subjectInfo: string[] = [];

        if (!!subjectNumberAndInitials) {
            subjectInfo.push(subjectNumberAndInitials);
            if (subjectNumberAndInitials !== this.removedSubjectLabel) {
                const emptyChar = ': ';
                if (!!x.data.screeningNumber) {
                    subjectInfo.push(`: (${x.data.screeningNumber})`);
                } else {
                    subjectInfo.push(emptyChar);
                }
                if (!isNil(x.data.age)) {
                    subjectInfo.push(`: ${x.data.age} : ${x.data.ageUnit}`);
                } else {
                    subjectInfo.push(emptyChar + emptyChar);
                }
                if (!isNil(x.data.ageProjectDisplayValue)) {
                    subjectInfo.push(`: ${x.data.ageProjectDisplayValue} `);
                } else {
                    subjectInfo.push(emptyChar + emptyChar);
                }
                if (!!x.data.sex) {
                    subjectInfo.push(`: ${x.data.sex}`);
                } else {
                    subjectInfo.push(emptyChar);
                }
            }
        }

        subjectInfo.push(`:${x.data.exportSortId}`);

        const result = {
            subjectNumberAndInitials: subjectNumberAndInitials,
            screeningNumber: x.data.screeningNumber,
            age: x.data.age,
            ageProjectDisplayValue: x.data.ageProjectDisplayValue,
            gender: x.data.sex,
            exportSortId: x.data.exportSortId,
            text: subjectNumberAndInitials,
            routerLink: [''],
            toString: () => subjectInfo.join(' '),
            data: x.data
        };

        return result;
    }

    public static renderSubjectNumberOrScreening(data: SubjectNumberOrScreeningParams): string {
        return data.subjectNumber
            ? data.subjectNumber
            : data.screeningNumber || '';
    }
}

interface SubjectTitleGetterParams {
    data: {
        subjectNumber: string;
        initials: string;
        screeningNumber: string;
        zcSubjectId: string;
    };
}

interface SubjectNumberOrScreeningParams {
    subjectNumber: string;
    screeningNumber: string;
}